import React from 'react';
import { humanize, titleize, unescapeHTML } from 'underscore.string';
import classnames from 'classnames';
import { Glyphicon } from 'react-bootstrap';

import { referenceNumberFormatter } from 'components/ui/formatters';
import { useTranslation } from 'react-i18next';

const Location = (props) => {
  const glyph = props.type === 'pickup' ? 'arrow-up' : 'arrow-down';

  const glyphClassName = classnames({
    'text-green': props.type === 'pickup',
    'text-red-500': props.type !== 'pickup',
    'pr-1': true,
  });

  return (
    <div>
      <div>
        <Glyphicon glyph={glyph} className={glyphClassName} />
        <span className="font-bold text-grey-darker">
          {titleize(props.location[0].name)}
        </span>
      </div>
      <div>
        <span>{props.location[0].address}</span>
      </div>
    </div>
  );
};

const ShipmentCard = (props) => {
  const s = props.shipment;
  const { t } = useTranslation();
  const wrapperClasses = classnames({
    'border-green-light': props.active,
    border: props.active,
    'border-solid': props.active,
    'border-transparent': !props.active,
  });

  return (
    <div
      className={`text-sm rounded-lg shadow p-2 bg-white cursor-pointer ${wrapperClasses}`}
    >
      <div onClick={() => props.onClick(s)}>
        <div className="flex border-solid border-bottom text-grey-darker">
          <div className="w-1/2">
            <a className="pt-1">{s.shipment_id}</a>
          </div>
          <div className="flex justify-end w-1/2">
            <span className="p-1 text-white rounded bg-green-light">
              {titleize(humanize(s.status))}
            </span>
          </div>
        </div>
        <div>
          <div className="mt-1">
            <span className="font-semibold text-blue-dark">
              {titleize(humanize(unescapeHTML(s.shipper_name)))}
            </span>
          </div>
          <div className="mt-1">
            <Location location={s.origin} type="pickup" />
          </div>
          <div className="mt-1">
            <Location location={s.destination} type="deliver" />
          </div>
          <div className="mt-1">
            {referenceNumberFormatter(s.reference_numbers)}
          </div>
        </div>
      </div>
      <div className="flex justify-end pt-2 border-t border-solid border-grey">
        <a target="_blank" href={`/shipments/${s._id}`} rel="noreferrer">
          {t('OPEN_IN_NEW_TAB')}
        </a>
      </div>
    </div>
  );
};

export default ShipmentCard;
